var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 90 90","xmlns":"http://www.w3.org/2000/svg"}},[_c('image',{attrs:{"href":_vm.logo,"x":"0","y":"0","width":"90","height":"90","preserveAspectRatio":"xMidYMid meet"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }